import styled, {ThemeProps} from 'styled-components';

import {Theme} from './../../../../theme/types';
import {
  Column,
  Row,
  SectionDefaultStyles,
  ColumnStyles,
  RowW100Styles,
} from './../../common/Layouts/Layouts';

export const ContentWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  // border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  background-color: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const HeadingTextWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  border-bottom: 0.1rem solid ${props.theme.colors.downriver.light};
  // background-color: white;
  padding: ${props.theme.spacing.xlarge}  ${props.theme.spacing.xxlarge};
`,
);

export const MainContentTextStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(16)};
  background: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  >p{
    height: 100%;
  }
  >ol, >ul{
    list-style: inside !important;
  }
`,
);

export const HeadingTextStyle = styled.h2(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(22)};
  font-weight: 600;
`,
);

export const WrapperSection = styled.section(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.light};
  width: 100%;
  flex-direction: column;
`,
);

export const WrapperDiv = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  padding-top: ${props.theme.spacing.large};
  margin: 0 auto;
`,
);

export const RoomInfoItemWrapperDiv = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  align-items: center;
`,
);

export const RoomInfoItemDetailsTextStyling = styled.span(
  props => `
  padding-right: ${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.base};
`,
);
